import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IconComponent } from '../../core';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'wp-sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrl: 'sidebar.component.scss',
  imports: [IconComponent, NgIf],
})
export class SidebarComponent implements OnInit {
  @Input({ required: true }) public brandIcon!: string;
  @Input({ required: true }) public brandLogo!: string;
  @Input({ required: true }) public brand!: string;

  public isCollapsed: boolean = false;

  constructor(private layoutService: LayoutService) {}

  public ngOnInit(): void {
    this.layoutService.isCollapsed$().subscribe({
      next: (isCollapsed: boolean) => (this.isCollapsed = isCollapsed),
    });
  }

  public onToggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    this.layoutService.setCollapsed(this.isCollapsed);
  }
}
